import styled from 'styled-components';

import SvgIcon from '../SvgIcon';

const ListItemIcon = styled.span`
  margin-right: 8px;

  ${SvgIcon} {
    width: 12px;
    height: 12px;
  }
`;

export default ListItemIcon;
